module.exports = __webpack_public_path__ + "static/media/approve.0528c420.png";